import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { MenuItem, MessageService } from 'primeng/api';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { ProductService } from 'src/app/services/shop/product.service';
import { ProdutoCategory } from 'src/app/models/productCategory';
import { NavbarService } from 'src/app/services/navbar-service';
import { Company } from 'src/app/models/company';
import { Verbas } from 'src/app/models/verbas';
//import { UploadEvent } from 'src/app/models/UploadEvent';

interface UploadEvent {
  originalEvent: Event;
  files: File[];
}


@Component({
  selector: 'app-gerenciador-produtos',
  templateUrl: './gerenciador-produtos.component.html',
  styleUrls: ['./gerenciador-produtos.component.scss'],
})
export class GerenciadorProdutosComponent implements OnInit {
  produtos: any[] = [];
  produto: any[] = [];
  productId: number = 0;
  representatives: any[];
  statuses: any[];
  loading: boolean = true;
  lazy: boolean = true;
  activityValues: number[] = [0, 100];

  items: MenuItem[] | undefined;
  activeItem: MenuItem | undefined;

  public userLogado: any;
  public loadingModalProduct: number;
  public showModalEditProduct: boolean;
  public editingProductForm: FormGroup;

  public copyProduct: any;
  public loadingUpdateProduct: boolean;
  navbarVisible: boolean;
  public formProduct: FormGroup | any;
  public companyes: Company[] = [];

  listCategory: ProdutoCategory[] = [];
  public verbasCompany: Verbas[] = [];
  public selectdverbasCompany: Verbas;

  public verbas: Verbas[] = [];
  public seletecdVerbas: Verbas;

  public companyesClient: Company[] = [];

  listCategorySelected: ProdutoCategory;

  constructor(
    public api: ApiService,
    public storageService: StorageService,
    private messageService: MessageService,
    public formBuilder: FormBuilder,
    public functionsService: FunctionsService,
    private productService: ProductService,
    private navbarService: NavbarService
  ) { }

  async ngOnInit() {
    this.formProduct = new FormGroup({
      categoriaLoja: new FormControl(<string | null>null, [Validators.required]),
      companyId: new FormControl(<string | null>null, [Validators.required]),
      empresaCliente: new FormControl(<string | null>null, [Validators.required]),
      verbasCompany: new FormControl(<string | null>null, [Validators.required]),
    });

    this.loadingUpdateProduct = false;
    this.showModalEditProduct = false;
    this.loadingModalProduct = -1;
    this.editingProductForm = this.formBuilder.group({
      product_description: [''],
      // storeCategory: [''],
      product_number_plots: [0],
      product_monthly_discount: [0],
      product_price: [0],
      id: [0],
      isActive: [true],
      taxa_adm: [0],
      comissao: [0],
      taxa_adesao: [0],
      taxaId: [0],
      details_product: ['']
    });
    try {
      this.userLogado = this.storageService.getUserLogado();
      this.carregarCategoriasDeLoja();
      this.loading = false;
    } catch (err: any) {
      console.log(err);
    }
    this.listCategoryProducts()


    this.navbarService.navbarVisible$.subscribe(show => {
      this.navbarVisible = show;
    });

    this.items = [
      { label: 'Produto', icon: 'pi pi-home' },
      { label: 'Verbas', icon: 'pi pi-chart-line' },
      { label: 'Imagens', icon: 'pi pi-list' },
    ];

    this.activeItem = this.items[0];

    this.getAllCompay()

  }

  onActiveItemChange(event: MenuItem) {
    this.activeItem = event;
  }


  carregarCategoriasDeLoja() {
    this.loading = true;
    this.produtos = [];
    this.api.obterProdutos(this.userLogado.token).subscribe((response: any) => {
      this.produtos = response.resultProducts;
      this.loading = false;
    });
  }

  carregarCategoriasDeLojaId() {
    this.produto = [];
    this.loading = true;

    const filterProduct = this.produtos.filter(p => p.id === this.productId)

    filterProduct[0].product_imgs.map((item: any) => {
      this.produto.push({
        name: item.img,
        img: `${this.api.urlApi}/aws/s3img/null/${this.userLogado.id}?img=${item.img}&token=${this.userLogado.token}`,
        id: item.product_fk,
        type: item.type
      });
    });
    this.loading = false;
  }

  editProduct(product: any, rowIndex: number) {
    this.productId = product.product_imgs[0].product_fk
    this.produto = []
    this.verbasCompany = [];
    this.editingProductForm.controls['product_description'].setValue(product.description);
    this.editingProductForm.controls['product_number_plots'].setValue(product.number_plots);
    this.editingProductForm.controls['product_monthly_discount'].setValue(product.valor_parcela);
    this.editingProductForm.controls['product_price'].setValue(product.price);
    this.editingProductForm.controls['id'].setValue(product.id);
    this.editingProductForm.controls['taxa_adm'].setValue(product.taxa_adm);
    this.editingProductForm.controls['comissao'].setValue(product.comissao);
    this.editingProductForm.controls['taxa_adesao'].setValue(product.taxa_adesao[0].taxa_adesao);
    this.editingProductForm.controls['taxaId'].setValue(product.taxa_adesao[0].id);
    this.editingProductForm.controls['details_product'].setValue(product.details_product);


    product.product_imgs.map((item: any) => {
      this.produto.push({
        name: item.img,
        img: `${this.api.urlApi}/aws/s3img/null/${this.userLogado.id}?img=${item.img}&token=${this.userLogado.token}`,
        id: item.product_fk,
        type: item.type
      });
    });
    this.showModalEditProduct = true;
  }

  extractFormValues(form) {
    let formValues = {};
    Object.keys(form.controls).forEach((key) => {
      formValues[key] = form.get(key).value;
    });
    return formValues;
  }

  async saveProductDb() {
    this.productService.putProduct(this.editingProductForm.value).subscribe({
      next: (res) => {
        const resConv: any = res;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: resConv.message,
        });
        this.showModalEditProduct = false;
        this.ngOnInit();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao atualizar o produto.',
        });
      }
    })

  }

  fieldsChanged(productChanged: any) {
    let fieldsChangeds = {};
    Object.keys(productChanged).forEach((key) => {
      if (
        this.copyProduct.product[key] !== productChanged[key] &&
        key !== 'created_at' &&
        key !== 'product_monthly_discount'
      ) {
        fieldsChangeds[key] = productChanged[key];
      }
    });

    console.log(fieldsChangeds);
    return fieldsChangeds;
  }

  listCategoryProducts() {
    this.productService.listCategoryProdutos().subscribe((res: any) => {
      res.map(item => {
        this.listCategory.push({
          description: item.description,
          id: item.id,
        })
      })
    })
  }

  async getAllCompay() {
    this.api.getAllcompany().subscribe(
      (result: any) => {
        const filterTypeCompany = result.filter((result: any) => result.tipo === 'Parceira');
        const filterTypeCompanyCliente = result.filter((result: any) => result.tipo === 'Cliente');
        filterTypeCompany.map((item: any) => {
          this.companyes.push(
            {
              nome_fantasia: item.nome_fantasia,
              id: item.id
            }
          )
        })
        filterTypeCompanyCliente.map((item: any) => {
          this.companyesClient.push({
            nome_fantasia: item.nome_fantasia,
            id: item.id
          })
        })

      }
    )
  }

  listVerbaByCompany() {
    const { id } = this.formProduct.value.empresaCliente
    this.api.listPaypmentCodeByCompany(id).subscribe((res: any) => {
      this.verbasCompany = [];

      res.map((item: any) => {
        this.verbasCompany.push({
          code: `${item.code}`,
          description: `${item.code}-${item.description}`,
          paypmentCodeFk: item.id
        })
      })
    })
  }

  addlistVerbaEmpresa() {
    const { code, description, paypmentCodeFk } = this.formProduct.value.verbasCompany;
    const { nome_fantasia } = this.formProduct.value.empresaCliente;
    const { id } = this.formProduct.value.empresaCliente;

    const filterCode = this.verbas.filter((item) => item.code === code && item.nome_fantasia === nome_fantasia)
    if (filterCode.length > 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Averbação',
        detail: 'Verba ja foi adicionada ao produto'
      })
    } else {
      this.verbas.push({
        code: code,
        nome_fantasia: nome_fantasia,
        description: description,
        company_fk: id,
        id: paypmentCodeFk
      })
    }
  }

  saveVerbasCompany() {
    const idProduct = this.editingProductForm.value.id;
    this.productService.addverbaCompany(this.verbas, idProduct).subscribe({
      next: (res) => {
        const resConv: any = res;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: resConv.message,
        });
        this.verbas = [];
        this.formProduct.reset();
      },
      complete: () => {
        this.showModalEditProduct = false;
      },

      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao salvar as verbas.',
        });
      }
    })
  }

  editImgProduct(event: { files: File[];[key: string]: any }, product: any) {
    this.loading = true
    this.showModalEditProduct = true;
    this.productId = product.id
    const formData = new FormData();
    for (let i = 0; i <= event.files.length; i++) {
      formData.append('arquivo', event.files[i])
    }
    formData.append('id', product.id)
    formData.append('url', product.name)

    this.productService.editImgProducts(formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: res.message,
        });
      },
      complete: () => {
        this.produto = []
        this.loading = false
        this.showModalEditProduct = true;
        this.ngOnInit()
      },
      error: () => { }
    })
  }

  deleteVerba(index: any) {
    const removeItemVerba = this.verbas.filter((verba, i) => i !== index)
    this.verbas = removeItemVerba
  }
}
